// Een melding met een knop erin. Bestaat apart van useDagstartData zodat de datalaag
// geen JSX hoeft te bevatten.
//
// Waarom er überhaupt een undo is: de dagstart gaat hardop en met een gedeeld scherm.
// Een misklik op het vinkje laat een taak voor de ogen van het hele team verdwijnen, en
// "wacht, hoe heette die ook alweer" is een pijnlijke manier om een ochtend te beginnen.
// Acht seconden is lang genoeg om te reageren en kort genoeg om niet in de weg te staan.

import React from 'react';
import toast from 'react-hot-toast';
import { Box, Button, Typography } from '@mui/material';

export const ONGEDAAN_DUUR = 8000;

export function toonOngedaanToast({ melding, onOngedaan }) {
  toast((t) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Typography sx={{ fontSize: '0.85rem' }}>{melding}</Typography>
      <Button
        size="small"
        onClick={() => { toast.dismiss(t.id); onOngedaan(); }}
        sx={{ textTransform: 'none', fontWeight: 700, py: 0, minWidth: 0, whiteSpace: 'nowrap' }}
      >
        Ongedaan maken
      </Button>
    </Box>
  ), { duration: ONGEDAAN_DUUR, icon: '✓' });
}
